import React from 'react';
import './Filters.css';

function Filters() {
  return (
    <div className="Filters">
        
    </div>
  );
}

export default Filters;